import React, { useState, useEffect } from "react";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { useJwt } from "react-jwt";
import Sidebar from "../components/Sidebar";
import Select from "react-select"; // Import react-select
import {
  CreateBrand,
  GetProductStatus,
  GetPageNumber,
  CreateWidget,
  GetPincodeProduct,
  GetProductCatWithoutPage,
  GetProductSubCatWithoutPage,
  EditWedgetProduct,
} from "../apiconfig/authService";
import { ToastContainer, toast } from "react-toastify"; // Import toastify
import "react-toastify/dist/ReactToastify.css"; // Import styles for toastify

function Addwidget(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("id????", id);
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setProductViewMessage = props.setMessage;
  const [widget, setWidget] = useState("");
  const [categoryStatusid, setCategoryStatusid] = useState(1);
  const [type, setType] = useState();
  const [statusData, setStatusData] = useState(null);
  const [pagenumber, setPagenumber] = useState([1]);
  const [product, setProduct] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [categoryID, setCategoryID] = useState(-1);
  const [subcategoryID, setSubcategoryID] = useState(-1);
  const [visibleSubcategories, setVisibleSubcategories] = useState([]);
  const [refetchData, setRefetchData] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [page, setPage] = useState(1);
  const [isMessageRed, setIsMessageRed] = useState(false);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const [selectedPageNumber, setSelectedPageNumber] = useState([]);
  const [position, setPosition] = useState();
  const [selectedCategories, setSelectedCategories] = useState([]); // Selected categories for multi-select
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category for single-select
  const handleStatusIdChange = (e) => {
    setCategoryStatusid(Number(e.target.value));
  };

  console.log("typechange???????????", type)
  const handleWidgetChange = (e) => setWidget(e.target.value);
  const handlePositionChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1) {
      setPosition(value);
    } else {
      setPosition(1); // Or handle it as per your requirement
    }
  };
  const handleTypeChange = (e) => setType(e.target.value);

  console.log("selectedPageNumber??????????", parseInt(selectedPageNumber));
  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        const pageNumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        setPagenumber(pageNumber.data);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  console.log("selectedwidget???????", widget);
  const handleSubmitClick = async (e) => {
    e.preventDefault();

    // Validate the widget title and page number
    if (!widget.trim()) {
      toast.error("Widget title is required!");
      return;
    }

    if (!selectedPageNumber || selectedPageNumber.length === 0) {
      toast.error("At least one page number must be selected!");
      return;
    }

    try {
      const categoryPayload =
        type === "category" ? selectedCategories : [categoryID];
      // Prepare payload for widget creation
      const response = await CreateWidget(
        {
          type: type,
          title: widget,
          statusid: categoryStatusid,
          pagenumber: selectedPageNumber,
          category: type === "product" ? [] : categoryPayload,
          position: position,
        },
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setProductViewMessage(response.data.message);
        setProductViewMessage("Widget created successfully!")
        toast.success("Widget created successfully!");
        navigate("/wedget");
      }

      // Handle selected products update if necessary
      const selectedProductIds = productData?.products?.map(
        (product) => product.value
      );

      if (selectedProductIds.length > 0) {
        const productUpdatePayload = {
          widgetId: response.data._id, // Use the created widget ID
          productIds: selectedProductIds,
        };

        const updateProductResponse = await EditWedgetProduct(
          productUpdatePayload,
          localStorage.getItem("accessToken")
        );

        if (updateProductResponse.status === 200) {
          setMessage("Widget and products updated successfully!");
          setProductViewMessage("Widget and products created successfully!")
          navigate("/wedget");
        } else {
          throw new Error("Failed to update products");
        }
      } else {
        navigate("/wedget");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error ||
        "An error occurred. Please try again later."
      );
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const pagenumber = await GetPageNumber(
          localStorage.getItem("accessToken")
        );
        const productData = await GetPincodeProduct(
          // page,
          // itemsPerPage,
          search,
          localStorage.getItem("accessToken"),
          categoryID,
          subcategoryID
        );
        setProduct(productData.data.products.items); // Set products for multi-select
        setPagenumber(pagenumber.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, search, refetchData, categoryID, subcategoryID]);
  useEffect(() => {
    (async () => {
      const categoryResponse = await GetProductCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      const subCategoryResponse = await GetProductSubCatWithoutPage(
        localStorage.getItem("accessToken")
      );
      setCategories(categoryResponse.data.categories);
      setSubcategories(subCategoryResponse.data.subcategories);
    })();
  }, []);
  const [productData, setProductData] = useState([]);
  const handleProductChange = (selectedOptions) => {
    // Update the selected product state
    setProductData({
      products: selectedOptions.map((option) => ({
        value: option.value, // Product ID
        label: option.label, // Display label
        image: option.image, // Image URL
      })),
    });

    // Log the selected product IDs in the console
    console.log(
      "Selected Products:",
      selectedOptions.map((option) => option.value)
    );

    // Log the full details of selected products
    console.log("Selected Product Details:", selectedOptions);
  };

  console.log("productData??????", productData);
  const handleSubcategoryIDChange = (e) => {
    setSubcategoryID(Number(e.target.value));
  };

  const handleCategoryIDChange = (e) => {
    setCategoryID(Number(e.target.value));
    setSubcategoryID(-1);
    setVisibleSubcategories(
      subcategories.filter((item) => item.categoryid === e.target.value)
    );
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setRefetchData(!refetchData);
  };

  const productOptions = product.map((item) => ({
    value: item._id,
    label: item.name,
    image: item.imageurl,
    weight: item.weight,
  }));
  console.log("productOptions??????", productOptions);
  console.log("pagenumber", pagenumber);
  const handlePageChange = (selectedOptions) => {
    // Extract only the page numbers from selected options
    const selectedValues = selectedOptions.map((option) => option.value);
    console.log("Selected Page Numbers:", selectedValues);

    // Update the state with selected page numbers
    setSelectedPageNumber([...selectedValues]);
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Widget</h1>
        </div>
        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "green" }}
            className="alert alert-primary"
          >
            {message}
          </div>
        )}
        <div className="personal-info tab-pane active storetab">
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="brandName">Widget Title</label>
              <input
                type="text"
                value={widget}
                onChange={handleWidgetChange}
                className="form-control custom-input my-2"
                id="widget"
                placeholder="Enter Widget Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Page Name</label>
              {/* <select
                className="form-select custom-input my-2"
                value={selectedPageNumber}
                onChange={handlePageNumber}
              >
                {pagenumber?.map((item) => (
                  <option key={item?.pagenumber} value={item?.pagenumber}>
                    {item.pagename}
                  </option>
                ))}
              </select> */}
              <Select
                isMulti
                options={pagenumber?.map((item) => ({
                  value: item?.pagenumber,
                  label: item?.pagename,
                }))}
                value={selectedPageNumber?.map((page) => {
                  const pageData = pagenumber.find((item) => item?.pagenumber === page);
                  return pageData ? { value: pageData.pagenumber, label: pageData.pagename } : null;
                }).filter(Boolean)}
                // onChange={(selectedOptions) => {
                //   const selectedValues = selectedOptions.map((option) => option.value);
                //   console.log("Selected Page Numbers:", selectedValues);

                //   // Update state with selected page numbers
                //   setSelectedPageNumber(selectedValues);
                // }}
                onChange={handlePageChange}
                className="basic-multi-select my-3"
                classNamePrefix="select"
                placeholder="Select Pages"
              />

            </div>
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-2"
              onChange={handleStatusIdChange}
              value={categoryStatusid}
            >
              {statusData?.map((item) => (
                <option key={item.statusid} value={item.statusid}>
                  {item.status}
                </option>
              ))}
            </select>
          </div>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="floatingInput">Type</label>
              <select
                className="form-select custom-input my-2"
                onChange={(e) => {
                  setType(e.target.value); // Update type state
                  if (e.target.value === "category") {
                    setSubcategoryID(-1); // Reset subcategory selection
                  }
                }}
                value={type} // Use the appropriate state for the selected value
              >
                <option value="">Select Type</option>
                <option value="category">Category</option>
                <option value="product">Product</option>
              </select>
            </div>

            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="brandName">Position</label>
              <input
                type="number"
                value={position}
                onChange={handlePositionChange}
                className="form-control custom-input my-2"
                id="widget"
                placeholder="Enter Widget Position"
                min={1} // Enforce minimum value
              />
            </div>
          </div>

          {/* Category and Subcategory inputs */}
          <form className="sForm" onSubmit={handleSearchBoxSubmit}>
            <div className="row">
              {/* <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="floatingInput">Category</label>
                <select
                  className="form-select my-2"
                  value={categoryID}
                  onChange={handleCategoryIDChange}
                >
                  <option value={-1}>Select a Category</option>
                  {categories
                    ?.sort((a, b) => a.name.localeCompare(b.name)) // Sort categories alphabetically
                    .map((item) => (
                      <option key={item.categoryid} value={item.categoryid}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div> */}
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <label htmlFor="floatingInput">Category</label>
                {type === "category" ? (
                  // Multi-select for categories
                  <Select
                    isMulti
                    closeMenuOnSelect={false}
                    options={categories.map((item) => ({
                      value: item._id,
                      label: item.name,
                    }))}
                    value={categories
                      .filter((cat) => selectedCategories.includes(cat._id))
                      .map((cat) => ({
                        value: cat._id,
                        label: cat.name,
                      }))}
                    onChange={(selected) =>
                      setSelectedCategories(
                        selected.map((option) => option.value)
                      )
                    }
                    placeholder="Select Category"
                    className="custom-select my-2"
                  />
                ) : (
                  // Single - select for categories
                  <select
                    className="form-select my-2"
                    value={categoryID}
                    onChange={handleCategoryIDChange}
                  >
                    <option value={-1}>Select Category</option>
                    {categories
                      ?.sort((a, b) => a.name.localeCompare(b.name)) // Sort categories alphabetically
                      .map((item) => (
                        <option key={item.categoryid} value={item.categoryid}>
                          {item.name}
                        </option>
                      ))}
                  </select>

                  // <Select
                  //   options={productOptions} // Pass the correctly structured productOptions
                  //   isMulti
                  //   onChange={handleProductChange} // Use onChange to handle selections
                  //   closeMenuOnSelect={false}
                  //   onInputChange={(inputValue) => setSearch(inputValue)} // Update search term on input change
                  //   filterOption={null} // Disable client-side filtering to rely on server-side filtering
                  //   getOptionLabel={(option) => (
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       <img
                  //         src={option.image}
                  //         alt={option.label}
                  //         style={{ width: 20, height: 20, marginRight: 10 }}
                  //       />
                  //       <span>{option.label}</span>
                  //       <span style={{ color: "#757575", fontSize: "14px", marginLeft: "15px" }}>
                  //         ({option.weight})
                  //       </span>
                  //     </div>
                  //   )}
                  //   getOptionValue={(option) => option.value} // Use the value property for unique identification
                  //   placeholder="Search and Select Products"
                  // />
                )}
              </div>

              {/* Sub Category field is conditionally rendered */}
              {/* {type !== "category" && (
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <label htmlFor="floatingInput">Sub Category</label>
                  <select
                    className="form-select my-2"
                    value={subcategoryID}
                    onChange={handleSubcategoryIDChange}
                    disabled={categoryID === -1}
                  >
                    <option value={-1}>Select a Subcategory</option>
                    {visibleSubcategories
                      ?.sort((a, b) => a.name.localeCompare(b.name)) // Sort subcategories alphabetically
                      .map((item) => (
                        <option
                          key={item.subcategoryid}
                          value={item.subcategoryid}
                        >
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>
              )} */}
            </div>
          </form>

          <div className="form-group col-sm-12 col-lg-12 mb-3">
            {categoryID !== -1 && ( // Only show "Select Products" if both category and subcategory are selected
              <>
                <label htmlFor="productSelect">Select Products</label>
                {/* <Select
                    options={productOptions}
                    isMulti
                    onChange={handleProductChange}
                    closeMenuOnSelect={false}
                    getOptionLabel={(option) => (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={option.image}
                          alt={option.label}
                          style={{ width: 20, height: 20, marginRight: 10 }}
                        />
                        <span>{option.label}</span>
                      </div>
                    )}
                    getOptionValue={(option) => option.value}
                  /> */}
                <Select
                  options={productOptions} // Pass the correctly structured productOptions
                  isMulti
                  onChange={handleProductChange} // Use onChange to handle selections
                  closeMenuOnSelect={false}
                  onInputChange={(inputValue) => setSearch(inputValue)} // Update search term on input change
                  filterOption={null} // Disable client-side filtering to rely on server-side filtering
                  getOptionLabel={(option) => (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <img
                        src={option.image}
                        alt={option.label}
                        style={{ width: 20, height: 20, marginRight: 10 }}
                      />
                      <span>{option.label}</span>
                      <span style={{ color: "#757575", fontSize: "14px", marginLeft: "15px" }}>
                        ({option.weight})
                      </span>
                    </div>
                  )}
                  getOptionValue={(option) => option.value} // Use the value property for unique identification
                  placeholder="Search and Select Products"
                />
              </>
            )}
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3 ">
            <button
              type="submit"
              onClick={handleSubmitClick}
              className="btn btn-primary save-btn text-uppercase px-4 my-3"
            >
              Add
            </button>
          </div>
        </div>
        <hr />
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
}

export default Addwidget;
